import { UserAdminReport } from '@/module/AnnualReport/perRole/UserAdminReport';

import { useCurrentUser } from '@feature/security';
import { ValidationStatus } from '@feature/validation';

export interface AuthorAdminReportProps {
  year: number;
  validationStatus: ValidationStatus | null;
  filterAfterAffiliation: boolean;
}

export function AuthorAdminReport({ year, validationStatus, filterAfterAffiliation }: AuthorAdminReportProps) {
  const { id } = useCurrentUser();

  return (
    <UserAdminReport
      userId={id}
      year={year}
      validationStatus={validationStatus}
      filterAfterAffiliation={filterAfterAffiliation}
    />
  );
}
